var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M12 4.286H7.714L6 0 4.285 4.286H0l3.708 3.129L1.714 12 6 9.165 10.285 12 8.292 7.415z","fill-rule":"evenodd"}})}
var staticRenderFns = []

export { render, staticRenderFns }